module.exports = __webpack_public_path__ + "static/img/tenderer_tit_icon.c5fd471f.png";